import { HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FeedbackService } from '../manik-library/FeedbackService';

import { DomSanitizer, Title } from '@angular/platform-browser';

declare var WizardEnquiry: any;

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.css'],
})
export class EnquiryComponent implements OnInit {
  rating: any = 0;
  Form1: FormGroup;
  binding: any;

  formData: any;
  @ViewChild('d1') d1:ElementRef;
  countryData: any;
  constructor(
    private _feedbackService: FeedbackService,
    public _routeParams: ActivatedRoute,
    private titleService: Title,

    private sanitizer: DomSanitizer
  ) {
    this.titleService.setTitle('Enquiry');
  }
  companyData: any = {};

  ngOnInit(): void {
    this.Form1 = new FormGroup({
      name: new FormControl(null, Validators.required),
      phone: new FormControl(null, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.minLength(10),
      ]),
      email: new FormControl(null, [
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'),
      ]),
      Comments: new FormControl(null),
    });
    const headers = new HttpHeaders({
      TenantID: 'INSTA.WEB',
    });
    this._feedbackService.getToken(headers).subscribe((data) => {
      let Authorization = data['ManikJSon'][0]['JSon0'];
      sessionStorage.setItem('sToken', Authorization);
      this.getHappyForm();
    });
  }

  getFormHTMLData(PORTALDS: string) {
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    sessionStorage.setItem("PortalDS", PORTALDS);
    const htmlHeaders = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      URL: "http://resources.manikworks.com/designer/workspace/uploads/enquiry/1/enquiry-form.html",
      PORTALDS: PORTALDS,
      HANDLE: slug,
      TYPE: "BIZENQUIRY",
      'Content-Type': 'application/json',
    });
    this._feedbackService.enquiryHTMLFormApi(htmlHeaders).subscribe((data: any) => {
      console.log(data);
      if(data.statusCode == 200) {
        this.formData = this.sanitizer.bypassSecurityTrustHtml(data.content);
        setTimeout(() => {
          WizardEnquiry();
        })
      }
    });
  }

  getHappyForm() {
    let slug: string = this._routeParams.snapshot.params['businessslug'];

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      Operation: 'FETCH.FEEDBACK.JSON',
      BusinessHandle: slug,
      'Content-Type': 'application/json',
    });
    this._feedbackService.getFeebackFormData(headers).subscribe((data) => {
      this.companyData = data['ManikJSon'][0]['JSon0'][0];
      this.countryData = data['ManikJSon'][0]['JSon3'][0];

      console.log('this.companyData ==================>>', this.companyData.PortalDS);
      this.getFormHTMLData(this.companyData.PortalDS);
    });
  }
  
  onClick() {
    console.log(this.Form1.value);
  }

  saveRatingAPI(numb) {
    let slug: string = this._routeParams.snapshot.params['businessslug'];
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + sessionStorage.getItem('sToken'),
      'Content-Type': 'application/json',
      Context: 'SUBMIT.REVIEW',
      PortalDS: 'DEVCITY',
    });
    let data = {
      items: [
        {
          BusinessHandle: slug,
          HonoRating: numb,
        },
      ],
    };
    this._feedbackService.saveFeedbackEmoji(data, headers).subscribe((data) => {
      this.rating = numb;
      console.log(data);
    });
  }
}
